import { Col, Form, Modal, Row } from 'react-bootstrap';
import { FormEvent, useState } from 'react';
import Button from 'components/base/Button';
import { ResourceTranscriptionInfo } from './DataDefinitions';
import { useEffect } from 'react';

interface ResourceTranscriptionModalProps {
  onSave: (filename: string, language: string, isSpeakerACoach: boolean, isSpeakerBCoach: boolean) => void;
  onClose: () => void;
  show: boolean;
  data?: ResourceTranscriptionInfo;
}

const ResourceTranscriptionModal = ({
  onSave,
  onClose,
  show,
  data
}: ResourceTranscriptionModalProps) => {

  const [resourceName, setResourceName] = useState(data?.resource.resource_name);
  const [language, setLanguage] = useState(data?.transcription.language);
  const [isSpeakerACoach, setSpeakerACoach] = useState(data?.transcription.speakerA === 'coach');
  const [isSpeakerBCoach, setSpeakerBCoach] = useState(data?.transcription.speakerB === 'coach');

  const handleSumbit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const filename = formData.get("filename") as string;
    const language = formData.get("language") as string;

    if (filename === '') return;  // error handling 1

    const isSpeakerACoach = formData.get("speakerA") as string;
    const isSpeakerBCoach = formData.get("speakerB") as string;

    if (isSpeakerACoach === null && isSpeakerBCoach === null) onSave(filename, language, false, false);

    (isSpeakerACoach === 'on') ? onSave(filename, language, true, false) : onSave(filename, language, false, true);
  };

  const handleClose = () => {
    // replace modified data with existing one
    setResourceName(data?.resource.resource_name);
    setLanguage(data?.transcription.language);
    setSpeakerACoach(data?.transcription.speakerA === 'coach');
    setSpeakerBCoach(data?.transcription.speakerB === 'coach');
    onClose();
  };

  useEffect(() => {
    //console.log("useEffect");
    setResourceName(data?.resource.resource_name);
    setLanguage(data?.transcription.language);
    setSpeakerACoach(data?.transcription.speakerA === 'coach');
    setSpeakerBCoach(data?.transcription.speakerB === 'coach');
  }, [data]);

  return (
    <Modal
      show={show}
      //onHide={onClose}
      size="lg"
      contentClassName="overflow-hidden"
    >
      <Modal.Header className="position-relative p-0">
        <h3 className='m-2'>Update file resource</h3>
      </Modal.Header>
      <Modal.Body className="p-0">
        {/* <ActionSection /> */}

        <Form className='m-3' onSubmit={handleSumbit}>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={2}>
              Filename
            </Form.Label>
            <Col sm={10}>
              <Form.Control id="formFilename" type="text" name="filename" placeholder="file name" required value={resourceName}
                onChange={(e) => setResourceName(e.target.value)} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={2}>
              Language
            </Form.Label>

            <Col sm={10}>
              <Form.Select id="formLanguage" name="language" value={language} onChange={(e) => setLanguage(e.target.value)}>
                <option>Select language</option>
                <option value="en_us">English/American</option>
              </Form.Select>
            </Col>
          </Form.Group>

          <fieldset>
            <Form.Group as={Row} className="mb-3">
              <Form.Label as="legend" column sm={2}>
                Who is the coach?
              </Form.Label>
              <Col sm={10}>
                <Form.Check
                  type="radio"
                  label="Speaker A"
                  name="speakerA"
                  id="formHorizontalRadios1"
                  checked={isSpeakerACoach}
                  onChange={() => { setSpeakerACoach(true); setSpeakerBCoach(false); }}
                />
                <Form.Check
                  type="radio"
                  label="Speaker B"
                  name="speakerB"
                  id="formHorizontalRadios2"
                  checked={isSpeakerBCoach}
                  onChange={() => { setSpeakerACoach(false); setSpeakerBCoach(true); }}
                />
              </Col>
            </Form.Group>
          </fieldset>

          <Form.Group as={Row} className="mb-3">
            <Col sm={{ span: 6 }}>
              <Button variant="warning" onClick={handleClose}> Discard changes </Button>
            </Col>
            <Col sm={{ span: 6 }} style={{ textAlign: 'right' }}>
              <Button variant="primary" type='submit'>Save changes </Button>
            </Col>
          </Form.Group>
        </Form>

      </Modal.Body>
    </Modal>
  );
};

export default ResourceTranscriptionModal;
